import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { DataTeamActionType, DataTeamStore } from './DataTeamReducer.types';

// @ts-ignore
export const initialState: DataTeamStore = Immutable.fromJS({
  isFetchingPatch: false,
  isFetching: false,
  isFetched: false, // will be `true` if teams has been fetched
  rejectedTeams: { count: 0, results: [] },
  pendingTeams: { count: 0, results: [] },
  allTeamCompetitions: Immutable.List(),
});

const DataTeamReducer = handleActions<any>(
  {
    TEAMS_REQUEST: (state: DataTeamStore) => state.set('isFetching', true),

    TEAMS_REQUEST_ALL: (state: DataTeamStore) => state.set('isFetching', true),

    TEAMS_RESPONSE_FAILURE: (state: DataTeamStore) => state.set('isFetching', false),

    TEAMS_RESPONSE_ALL: (state: DataTeamStore) => state.set('isFetching', false).set('isFetched', true),

    TEAMS_ACCEPT_FAILURE: (state: DataTeamStore) => state.set('isFetching', false),

    TEAMS_ACCEPT_SUCCESS: (state: DataTeamStore) => state.set('isFetching', false),

    TEAMS_REJECT_FAILURE: (state: DataTeamStore) => state.set('isFetching', false),

    TEAMS_REJECT_SUCCESS: (state: DataTeamStore) => state.set('isFetching', false),

    TEAMS_TERMINATE_FAILURE: (state: DataTeamStore) => state.set('isFetching', false),

    TEAMS_TERMINATE_SUCCESS: (state: DataTeamStore) => state.set('isFetching', false),

    USER_TEAMS_RESPONSE: (state: DataTeamStore, action: DataTeamActionType) => {
      const validStatus = Immutable.Set.of('PENDING', 'TERMINATED');

      if (action.payload.status && validStatus.includes(action.payload.status)) {
        const status: any = `${action.payload.status ? action.payload.status.toLowerCase() : ''}Teams`;
        let newState = state;

        if (action.payload.data.hasOwnProperty('count')) {
          newState = newState.setIn([status, 'count'], action.payload.data.count);
        }
        if (action.payload.data.hasOwnProperty('results')) {
          const results = action.payload.data.results.map((result: any) => {
            if (result.status === 'PENDING') {
              const lastUserToActivateTeam =
                result.members.filter((user: any) => user.status === 'ACCEPTED').length === result.members.length - 1;
              result.lastUserToActivateTeam = lastUserToActivateTeam;

              return result;
            } else {
              return result;
            }
          });
          newState = newState.setIn([status, 'results'], Immutable.fromJS(results));
        }

        return newState;
      } else {
        return state;
      }
    },

    USER_COMPETITIONS_SUCCESS: (state: DataTeamStore, action: DataTeamActionType) => {
      if (action.payload.results) {
        let competitionTeamBased = Immutable.fromJS(action.payload.results.filter((competiton: any) => competiton.teamBased === true));
        // @ts-ignore
        competitionTeamBased = competitionTeamBased.size !== 0 ? competitionTeamBased : Immutable.List();

        return state.set('allTeamCompetitions', competitionTeamBased);
      }

      return state;
    },

    CLEAR_TEAMS: (state: DataTeamStore) =>
      state
        .set('isFetchingPatch', false)
        .set('isFetching', false)
        .set('isFetched', false)
        .set('rejectedTeams', Immutable.fromJS({ count: 0, results: [] }))
        .set('pendingTeams', Immutable.fromJS({ count: 0, results: [] }))
        .set('allTeamCompetitions', Immutable.List()),

    TEAM_UPDATE_REQUEST: (state: DataTeamStore) => state.set('isFetchingPatch', true),
    TEAM_UPDATE_REPONSE_SUCCESS: (state: DataTeamStore) => state.set('isFetchingPatch', false),
    TEAM_UPDATE_REPONSE_FAILURE: (state: DataTeamStore) => state.set('isFetchingPatch', false),
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);

export default DataTeamReducer;
